export const leave = [
    {
        id: "LT748294",
        leaveType: "Medical Leave",
        status: "Active"
      },
      {
        id: "LT748293",
        leaveType: "Casual Leave",
        status: "Active"
      },
      {
        id: "LT748292",
        leaveType: "Maternity Leave",
        status: "Active"
      },
      {
        id: "LT748291",
        leaveType: "Sick Leave",
        status: "Active"
      },
      {
        id: "LT748290",
        leaveType: "Paternity Leave",
        status: "Inactive"
      },
      {
        id: "LT748289",
        leaveType: "Special Leave",
        status: "Inactive"
      }
]
